import { motion } from "framer-motion";
import { Instagram as InstagramIcon, ArrowUpRight } from "lucide-react";
import { IMAGES, CH1, CH2, SALON, CUISINE, EXT, VILLA } from "../data";
import { useLang } from "../i18n";

const tile = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.07, ease: [0.19, 1, 0.22, 1] } }),
};

const PHOTOS = [SALON.p1, CH1.bedroom1, IMAGES.hero, EXT.nightVilla, CH2.p1, CUISINE[0]];

export const InstagramFeed = () => {
  const { t } = useLang();
  return (
    <section id="instagram" className="bg-sand-deep border-t border-[var(--line)] py-24 md:py-32" data-testid="instagram-section">
      <div className="px-6 md:px-12 max-w-[1600px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <span className="text-[11px] tracking-[0.35em] uppercase text-terracotta">Instagram</span>
            <h2 className="font-serif font-light text-4xl md:text-6xl mt-4 tracking-tight">{t.instagram.title}</h2>
          </div>
          <a
            href={VILLA.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="group inline-flex items-center gap-3 border border-ink text-ink px-6 py-3 text-sm hover:bg-ink hover:text-sand-bg transition-colors duration-300 self-start md:self-auto"
          >
            <InstagramIcon className="w-4 h-4" strokeWidth={1.5} />
            {t.instagram.cta}
            <ArrowUpRight className="w-4 h-4 opacity-60 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-3 md:gap-4">
          {PHOTOS.map((src, i) => (
            <motion.a
              key={i}
              custom={i}
              variants={tile}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              href={VILLA.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="group relative aspect-square overflow-hidden"
            >
              <img
                src={src}
                alt={`${VILLA.instagramHandle} — Villa Tutto Passa`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-ink/0 group-hover:bg-ink/40 transition-colors duration-500 flex items-center justify-center">
                <InstagramIcon className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500" strokeWidth={1.5} />
              </span>
            </motion.a>
          ))}
        </div>

        <p className="mt-6 text-center text-sm text-ink-soft">
          <a href={VILLA.instagram} target="_blank" rel="noopener noreferrer" className="link-underline" data-testid="instagram-handle-link">
            {VILLA.instagramHandle}
          </a>
        </p>
      </div>
    </section>
  );
};
